module.exports = __webpack_public_path__ + "static/amazon-f37c9d9eaa15b62f5d46a5032f0227b5.png";